import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { COUNTRIES_DATA } from 'src/assets/countriesData';

@Component({
  selector: 'app-custom-country-picker',
  templateUrl: 'custom-country-picker.component.html',
  styleUrls: ['./custom-country-picker.page.scss']
})
export class CustomCountryPickerComponent implements OnInit {
  searchResults: any[] = [];
  selectedCountries: string[] = [];
  searchFullResults: any[] = [];
  noResultsFound = false;
  isLoading = false;
  searchFilter = '';
  currentLanguage: string;

  constructor(
    public popoverController: PopoverController
  ) {
  }

  ngOnInit() {
    setTimeout(() => {
      //this.searchBar.setFocus();
    }, 800);
    this.loadCountries();
  }

  loadCountries(){
    this.searchResults = Object.keys(COUNTRIES_DATA)
        .filter((key) =>
          this.selectedCountries.includes(COUNTRIES_DATA[key].alpha3Code)
        )
        .map((key) => ({ ...COUNTRIES_DATA[key], flag: key }));
    this.searchFullResults = this.searchResults;
  }

  search(ev: any) {
    const searchTerm = ev.detail.value;
    
    if (!searchTerm) {
      this.searchResults = this.searchFullResults;
      return;
    }
  
    this.searchResults = this.searchResults.filter(
      (item) =>
        item.name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1
    );
  }

  selectCountry(country: any) {
    this.popoverController.dismiss({
      data: country
    });
  }

  closeModal(){
    this.popoverController.dismiss();
  }
}